<template>
	<div class="main-container full-view" :class="!isClient ? 'pcweb' : ''">
		<template v-if="init">
			<dggj-header v-if="pcIsDggj"></dggj-header>
			<auth-header v-if="!pcIsDggj"></auth-header>
			<router-view></router-view>

			<update-dialog></update-dialog>

			<login-view></login-view>

			<context-menu></context-menu>
		</template>
	</div>
</template>

<script>
import { MessageBox } from "element-ui";
import {CheckLibs,UserService,UtilLibs,DscStorageLib} from '@digital-supply-chain/module'
import { WinForm, DomainService, UtilService, IframePostMessage } from "@/libs";
import { UserService as ProdUserService } from "@/service";

import AuthHeader from './auth-header.vue'
import DggjHeader from './dggj-header.vue'
import LoginView from './login.vue'
import UpdateDialog from "@/components/updateDialog.vue";

import ContextMenu from "@/components/context-menu/index.vue";

export default {
	components: { UpdateDialog, ContextMenu, AuthHeader, DggjHeader, LoginView },
	data() {
		return {
			isClient: CheckLibs.isClient(),
			pcIsDggj: location.origin.includes('global-dsc.'),
			init: false,
		}
	},
	mounted() {
		WinForm.md.$on("solid_works_plugin_update", (value) => {
			MessageBox.alert(value.message, "提示", {
				confirmButtonText: "确定",
				callback: (action) => {
					if (value.status === 0) {
						WinForm.md.$emit("client_update_start", "client,plugin");
					}
				},
			});
		});

		// 初始化文件下载列表
		WinForm.md.initWindow(`${DomainService.ImWeb}/views/downlist.html`, 900, 600);
		// 图片预览
		WinForm.md.initWindow(`${DomainService.ImWeb}/local_lib/imgviewer.html`, 900, 600);

		// 客户端版本更新，soildworks插件更新页面
		WinForm.md.initWindow(`${DomainService.ImWeb}/views/program-update.html`, 900, 600);
		setTimeout(() => {
			WinForm.md.$emit("client_update_start", "client,plugin");
		}, 2000);

		this.setActivity();

		const {geometric} = this.$route.query || {};
		// 是否显示几何搜索按钮
		if (geometric) sessionStorage.setItem('geometric', geometric);
		this.initStart();
	},
	methods: {
		async initStart() {
			await this.GetTokenUserInfo();

			const iframeAgent = await UtilService.GetIframeAgent();
			DscStorageLib.sessionSet(IframePostMessage.NeIframeAgent, iframeAgent);

			this.init = true;
		},

		setActivity() {
			UserService.setActivity(1);
		},

		async GetTokenUserInfo(){
			const urlParams = UtilLibs.getUrlParamObj(location.href);
			if (urlParams.token) {
				try {
					const res = await ProdUserService.GetTokenUserInfo(urlParams.token);
					if (res) UserService.setUserOfBrowser(res);
				} catch (error) {}
			}
		},
	},
};
</script>

<style lang="less" scoped>
.main-container {
	padding: 10px;
	overflow: auto;
	background: @content-bg;
	&.pcweb{
		padding: 0;
	}
	&.pcweb /deep/ .layout-router{
		width: 1200px;
		margin: 0 auto;
	}
}
</style>
